import React, { ReactNode } from "react";
import { Flex, Text } from "@fluentui/react-northstar";
import MultipleChoiceFilter, { MultipleChoiceFilterItem } from "shared/components/MultipleChoiceFilter/MultipleChoiceFilter";
import ClearInputIcon from "shared/components/clearInputIcon/ClearInputIcon";
import styles from "./multipleChoiceNoteFilter.module.scss";

export interface IMultipleChoiceNoteFilterProps {
    title: string;
    availableChoices: MultipleChoiceFilterItem[];
    selectedChoices: MultipleChoiceFilterItem[];
    setFilter: (selectedItems: any) => void;
    clearInputDisabled: boolean;
}

const MultipleChoiceNoteFilter: React.FC<IMultipleChoiceNoteFilterProps> = ({
    title,
    availableChoices,
    selectedChoices,
    setFilter,
    clearInputDisabled,
}) => {

    return (
        <Flex column>
            <Text>{title}</Text>
            <Flex vAlign="center" fill>
                <MultipleChoiceFilter
                    key={title}
                    availableChoices={availableChoices}
                    selectedChoices={selectedChoices}
                    onSelectionChanged={(selectedItems: any) => {
                        setFilter(selectedItems);
                    }}
                    notInverted
                    className={styles.mulitpleDropdown}
                />
                <ClearInputIcon
                    disabled={clearInputDisabled}
                    onClick={() => setFilter([])}
                />
            </Flex>
        </Flex>
    )
}

export default MultipleChoiceNoteFilter;